export default __webpack_public_path__ + "static/media/D005_tn.3eecb0f9.jpg";